import React from 'react'

import type { Incentive as IncentiveType } from '../../../../Recommendations.types'
import { getBonus } from '../../utils'
import { Incentive } from '../Incentive'

type Props = {
  incentive: Extract<IncentiveType, { type: 'MAKE_FIRST_SALES' }>
}

export const MakeYourFirstSalesIncentive = ({ incentive }: Props) => {
  return (
    <Incentive
      type={incentive.type}
      icon="💵"
      label={`Make your first ${incentive.amountToMake} sales`}
      isCompleted={incentive.isCompleted}
      bonus={getBonus(incentive.bonus)}
    />
  )
}
